<template>
    <a class="inline-block primary-bg-color text-white px-14 py-4">
        <slot></slot>
    </a>
</template>
